import { css, cx } from "@microbit/ui";

interface EmojiArrowProps {
  /** One call site sizes the arrow like UpCurveArrow. */
  size?: "default" | "tall";
  className?: string;
}

const EmojiArrow = ({ size = "default", className }: EmojiArrowProps) => {
  return (
    <svg
      viewBox="0 0 19 12"
      aria-hidden
      className={cx(
        css({ flexShrink: 0 }),
        size === "tall"
          ? css({ w: "60px", h: "93px" })
          : css({ w: "55px", h: "34.73px" }),
        className
      )}
    >
      <path
        d="M18.481 11.2107C17.3447 7.88208 14.9828 5.11145 11.8759 3.46268C8.76898 1.81392 5.1506 1.41091 1.75707 2.33566L2.50742 0.867992C2.54366 0.799155 2.56579 0.723774 2.5725 0.646269C2.57921 0.568765 2.57038 0.490699 2.54651 0.416656C2.52264 0.342614 2.48422 0.27408 2.43351 0.215087C2.3828 0.156094 2.32081 0.107831 2.25119 0.0731207C2.18235 0.0368784 2.10697 0.0147501 2.02946 0.00803769C1.95196 0.00132532 1.8739 0.0101634 1.79986 0.0340314C1.72582 0.0578995 1.65728 0.0963152 1.59829 0.147028C1.5393 0.197741 1.49103 0.259732 1.45632 0.329353L0.0671462 3.04866C0.0309462 3.11751 0.00885674 3.19288 0.00216615 3.27038C-0.00452443 3.34787 0.00432106 3.42592 0.0281856 3.49995C0.0520502 3.57398 0.0904499 3.64251 0.14114 3.70151C0.191829 3.7605 0.253787 3.80878 0.323379 3.84352L3.04109 5.23276C3.18084 5.30209 3.34214 5.3141 3.49062 5.26624C3.6391 5.21838 3.76301 5.11442 3.83596 4.97653C3.87216 4.90768 3.89425 4.83231 3.90094 4.75481C3.90763 4.67732 3.89879 4.59927 3.87492 4.52524C3.85106 4.45121 3.81266 4.38269 3.76197 4.32369C3.71128 4.2647 3.64931 4.21641 3.57972 4.18167L2.15983 3.45594C5.24568 2.62979 8.53019 3.00751 11.348 4.51256C14.1657 6.01761 16.3061 8.53746 17.3354 11.5616C17.3891 11.7121 17.4992 11.8357 17.6425 11.9064C17.7836 11.9709 17.9417 11.9882 18.0934 11.956C18.1671 11.9373 18.2362 11.9034 18.2962 11.8565C18.3561 11.8097 18.4057 11.7508 18.4416 11.6837C18.4802 11.6117 18.5036 11.5326 18.5104 11.4512C18.5171 11.3698 18.5074 11.2881 18.481 11.2107Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EmojiArrow;
